import { TMessage } from '@core/context/messageContext/types';

import { EInternalTerm, TMessageResponse } from './types';

export const getMessageFromInternalTerm = (
  message: TMessage,
  t: (key: string) => string,
): TMessageResponse => {
  switch (message.internalTerm) {
    case EInternalTerm.PAYMENT_ALREADY_PROCESSED:
      return {
        status: 'success',
        description:
          message?.description || t('CommonMessages.payment.alreadyProcessed.description'),
      };

    case EInternalTerm.PAYMENT_NOT_FOUND:
      return {
        status: 'error',
        title: t('CommonMessages.payment.notFound.title'),
        description: message?.description || t('CommonMessages.payment.notFound.description'),
      };

    case EInternalTerm.CHECKOUT_PAYMENT_NOT_FOUND:
      return {
        status: 'error',
        title: t('CommonMessages.payment.checkoutNotFound.title'),
        description:
          message?.description || t('CommonMessages.payment.checkoutNotFound.description'),
      };

    case EInternalTerm.INVALID_REQUEST:
    case EInternalTerm.INTERNAL_ERROR:
    default:
      return {
        status: 'error',
        description: message?.description || t('CommonMessages.errorMessages.genericError'),
      };
  }
};
